import axios from 'axios';
import {
    GET_FREE_HOURS_FOR_DATE, GET_BUSY_DATES, GET_FREE_RESTAURANT_HALLS, RESERVATION_CENCELED, GET_ALLOWED_PEOPLE_FOR_TIME,
    SET_LOADING, GET_CURRENT_RESERVATION_INFO
} from './types';
import { API_URL } from './../../constants';
import { addErrorMessages, addSuccessMessage } from './../../messages/messages.actions';
import history from './../../utils/history';

export const makeReservation = (data) => dispatch => {

    return axios.post(API_URL + 'reservations',
        data
    )

    // .then(res => {
    //     console.log(res)
    // }).catch(error => {
    //     dispatch(addErrorMessages(["Моля попълнете коректно всички данни"]));
    // });

}

export const getReservationByUUID = (uuid, placeId) => dispatch => {
    axios.get(API_URL + 'reservations/read/' + uuid + '?place_id=' + placeId,
        {
            headers: {
                place: placeId
            }
        }

    ).then(res => {
        dispatch({
            type: GET_CURRENT_RESERVATION_INFO,
            payload: res.data
        });
    }).catch(error => {
        dispatch(addErrorMessages(["Няма данни за резервация"]));
    });

}

export const getBusyDatesForReservations = (data) => dispatch => {

    axios.post(API_URL + 'reservations/getBusyDates',
        data
    ).then(res => {
        dispatch({
            type: GET_BUSY_DATES,
            payload: res.data
        });
    }).catch(error => {
        dispatch(addErrorMessages(["Моля попълнете коректно всички данни"]));
    });
}

export const getFreeHoursForDate = (reservationDate, peopleCount) => dispatch => {

    dispatch(setLoading(true));
    axios.post(API_URL + 'reservations/getFreeHoursForDate', { 'reservationDate': reservationDate, 'peopleCount': peopleCount }
    ).then(res => {
        dispatch({
            type: GET_FREE_HOURS_FOR_DATE,
            payload: res.data
        });
        dispatch(setLoading(false));

    }).catch(error => {
        dispatch(addErrorMessages(["Грешка"]));
    });
}





export const getFreeRestaurantHalls = (reservationDate, reservationTime, peopleCount) => dispatch => {
    return axios
        .post(API_URL + 'reservations/getFreeRestaurantHalls', {
            "reservationDate": reservationDate,
            "reservationTime": reservationTime,
            "peopleCount": peopleCount
        })
    // .then(res => {
    // dispatch({
    //     type: GET_FREE_RESTAURANT_HALLS,
    //     payload: res.data
    // })
    // }
    // ).catch(error => {
    //     console.log(error);
    //     // dispatch({
    //     //     type: LIST_ROOMS_ERROR,
    //     //     payload: (error.response && error.response.data) ? error.response.data : {message: errorHandler(error)}
    //     // })
    // });
}

export const setFreeRestaurantHalls = (halls) => dispatch => {
    dispatch({
        type: GET_FREE_RESTAURANT_HALLS,
        payload: halls
    })
}

export const setLoading = (loading = false) => dispatch => {
    // console.log("LOADING ", loading)
    dispatch({
        type: SET_LOADING,
        payload: loading
    })
}


// export const makeReservation = (data) => dispatch => {  
//     let reservationErrorText = document.querySelector('.reservation-error-text');
//     if (reservationErrorText) {
//         reservationErrorText.classList.add('dnone');
//     }

//     let loadingIcon = document.querySelector('.reservation-loading-icon');
//     if (loadingIcon) {
//         loadingIcon.classList.remove('dnone');
//     }

//     axios
//     .post(API_URL + 'reservation/create', data)
//     .then(res => {
//         dispatch({
//             type: RESERVATION_CREATED,
//             payload: res.data
//         });
//         if (reservationErrorText) {
//             reservationErrorText.classList.remove('dnone');
//         }
//         if (loadingIcon) {
//             loadingIcon.classList.add('dnone');
//         }

//     }
//     ).catch(error => {
//         dispatch({
//             type: RESERVATION_ERROR,
//             payload: (error.response && error.response.data) ? error.response.data : {message: errorHandler(error)}
//         });
//         if (reservationErrorText) {
//             reservationErrorText.classList.remove('dnone');
//         }
//         if (loadingIcon) {
//             loadingIcon.classList.add('dnone');
//         }

//     });
// }

export const cancelReservation = (data) => dispatch => {
    axios
        .post(API_URL + 'reservations/cancel', data)
        .then(res => {
            dispatch({
                type: RESERVATION_CENCELED,
                payload: res.data
            })
        }
        ).catch(error => {

        });
}

// export const getReservationsSettings = () => dispatch => {
//     axios
//     .get(API_URL + 'settings/read')
//     .then(res => {
//         dispatch({
//             type: LIST_SETTINGS,
//             payload: res.data
//         })
//     }
//     ).catch(error => 
//         dispatch({
//             type: LIST_SETTINGS_ERROR,
//             payload: (error.response && error.response.data) ? error.response.data : {message: errorHandler(error)}
//         })
//     );
// }

export const checkIfFreeTablesForTime = (data) => dispatch => {
    axios
        .post(API_URL + 'reservations/checkIfFreeTablesForTime', data)
        .then(res => {
            // dispatch({
            //     type: FREE_TABLES_FOR_TIME,
            //     payload: res.data.status 
            // })
        }
        ).catch(error => {

        }
        );
}


export const getAllowedCountPeople = (getAllowedCountPeopleQuery = '') => dispatch => {
    axios
        .get(API_URL + 'reservation/getAllowedPeopleForTime' + getAllowedCountPeopleQuery)
        .then(res => {
            dispatch({
                type: GET_ALLOWED_PEOPLE_FOR_TIME,
                payload: res.data
            })
        }
        ).catch(error => {

        }


        );
}
